export const STAFF_RECEIVED = "STAFF_RECEIVED";
export const STAFF_INVITE_SENT = "STAFF_INVITE_SENT";
export const STAFF_CREATED = "STAFF_CREATED";
export const STAFF_UPDATED = "STAFF_UPDATED";
export const STAFF_DELETED = "STAFF_DELETED";
